// This file is auto-generated by @hey-api/openapi-ts

import type {
  GetExperienceListNewResponse,
  GetExperienceListResponse,
  GetExperiencesByIdsResponse,
  ListTravelerOrdersResponse,
} from './types.gen';

const expGuideSchemaResponseTransformer = (data: any) => {
  if (data.date_joined) {
    data.date_joined = new Date(data.date_joined);
  }
  if (data.is_guide_since) {
    data.is_guide_since = new Date(data.is_guide_since);
  }
  return data;
};

const experienceSchemaResponseTransformer = (data: any) => {
  data.guide = expGuideSchemaResponseTransformer(data.guide);
  return data;
};

export const getExperienceListResponseTransformer = async (data: any): Promise<GetExperienceListResponse> => {
  data.results = data.results.map((item: any) => experienceSchemaResponseTransformer(item));
  return data;
};

const orderEventSchemaResponseTransformer = (data: any) => {
  if (data.aware_start_dt) {
    data.aware_start_dt = new Date(data.aware_start_dt);
  }
  if (data.date) {
    data.date = new Date(data.date);
  }
  return data;
};

const orderSchemaResponseTransformer = (data: any) => {
  if (data.event) {
    data.event = orderEventSchemaResponseTransformer(data.event);
  }
  return data;
};

const ordersListSchemaResponseTransformer = (data: any) => {
  if (data.results) {
    data.results = data.results.map((item: any) => orderSchemaResponseTransformer(item));
  }
  return data;
};

export const listTravelerOrdersResponseTransformer = async (data: any): Promise<ListTravelerOrdersResponse> => {
  data = ordersListSchemaResponseTransformer(data);
  return data;
};

export const getExperiencesByIdsResponseTransformer = async (data: any): Promise<GetExperiencesByIdsResponse> => {
  data.results = data.results.map((item: any) => experienceSchemaResponseTransformer(item));
  return data;
};

export const getExperienceListNewResponseTransformer = async (data: any): Promise<GetExperienceListNewResponse> => {
  data.results = data.results.map((item: any) => experienceSchemaResponseTransformer(item));
  return data;
};
